export const LOGIN = 'USER_FETCH_REQUESTED'
export const LOGOUT = 'USER_LOGOUT'
export const USER_LOGGED_IN = 'USER_FETCH_SUCCEEDED'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_LOGIN_ERROR = 'USER_FETCH_FAILED'
export const USER_NOT_FOUND = 'USER_NOT_FOUND'
export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD'
export const USER_RECOVERY_PASS_SUCCEEDED = 'USER_RECOVERY_PASS_SUCCEEDED'
export const USER_RECOVERY_PASS_FAILED = 'USER_RECOVERY_PASD_FAILED'
export const EMAIL_USER_NOT_FOUND_SUCCEEDED = 'EMAIL_USER_NOT_FOUND_SUCCEEDED'
export const EMAIL_USER_NOT_FOUND_FAILED = 'EMAIL_USER_NOT_FOUND_FAILED'

export const recovery_password = ({ email }) =>
  ({ type: RECOVERY_PASSWORD, payload: { email } })

export const userRecoveryPasswordSucceeded = () =>
  ({ type: USER_RECOVERY_PASS_SUCCEEDED, payload: {} })

export const userRecoveryPasswordFailed = ({ email }) =>
  ({ type: USER_RECOVERY_PASS_FAILED, payload: { email } })

export const emailUserNotFoundSucceeded = () =>
  ({ type: EMAIL_USER_NOT_FOUND_SUCCEEDED, payload: {} })

export const emailUserNotFoundFailed = ({ name, email, comments }) =>
  ({ type: EMAIL_USER_NOT_FOUND_FAILED, payload: { name, email, comments } })

export const user_not_found = ({ name, comments, email }) =>
  ({ type: USER_NOT_FOUND, payload: { name, comments, email } })

export const logout = () =>
  ({ type: LOGOUT, payload: {} })

export const userLogout = () =>
  ({ type: USER_LOGGED_OUT, payload: {} })

export const login = ({ email, password }) =>
  ({ type: LOGIN, payload: { email, password } })

export const userFetchFailed = ({ email }) =>
  ({ type: USER_LOGIN_ERROR, payload: { email } })

export const userFetchSucceeded = ({ id, first_name, last_name, email, team_id, client_id,
  username, updated_at, firebase_access_token, access_token, image_url, staging_mode }) => ({
    type: USER_LOGGED_IN,
    payload: {
      id,
      first_name,
      last_name,
      email,
      team_id,
      client_id,
      username,
      updated_at,
      firebase_access_token,
      access_token,
      image_url,
      staging_mode,
    },
  })



// WEBPACK FOOTER //
// ./src/actions/login.jsx